import React, { useEffect, useState } from 'react';
import { Item } from '../../types';
import styles from './Projects.module.css';
import ProjectModal from './ProjectModal/ProjectModal';

type Props = { projects: Item[] };

interface GroupedProject {
  company: string;
  projects: Item[];
}

const Projects = ({ projects }: Props) => {
  const [sortedProjects, setSortedProjects] = useState<any>();

  const [modalContent, setModalContent] = useState<Item | undefined>(undefined);

  const [isProjectExpanded, setIsProjectExpanded] = useState(false);

  const groupAndSortProjects = (projects: Item[]): GroupedProject[] => {
    const grouped = projects.reduce<Record<string, Item[]>>((acc, project) => {
      const company = project.fields.company || '';
      if (!acc[company]) {
        acc[company] = [];
      }
      acc[company].push(project);
      return acc;
    }, {});

    for (const company in grouped) {
      grouped[company].sort((a, b) => a.fields.sortOrder - b.fields.sortOrder);
    }

    const groupedArray: GroupedProject[] = Object.entries(grouped).map(
      ([company, projects]) => ({
        company,
        projects,
      })
    );

    groupedArray.sort((a, b) => {
      if (a.company === 'Personal Projects') return 1;
      if (b.company === 'Personal Projects') return -1;
      return 0;
    });

    return groupedArray;
  };

  useEffect(() => {
    projects && setSortedProjects(groupAndSortProjects(projects));
  }, [projects]);

  const ProjectItem = ({
    project,
    isAccordion,
  }: {
    project: Item;
    isAccordion?: boolean;
  }) => {
    if (isAccordion) {
      return <p>Hello!</p>;
    }

    return (
      <div
        className={styles.projectContainer}
        onClick={() => setModalContent(project)}
      >
        <h4 className={styles.title}>
          {project.fields.title}{' '}
          <div className={styles.exploreButton}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
              <path d="M21 21l-6 -6" />
            </svg>

            <p className={styles.explore}>Explore</p>
          </div>
        </h4>
        <p className={styles.description}>{project.fields.description}</p>

        <img
          className={styles.projectImage}
          src={project.fields.images?.[0].fields.file.url}
          alt={project.fields.title}
        />
      </div>
    );
  };

  return (
    <div className={styles.mainContainer}>
      <h2 className={styles.pageTitle}>Projects</h2>

      {sortedProjects?.map((companyGroup: GroupedProject, i: number) => (
        <div
          className={`${styles.companyContainer}  ${
            companyGroup.company === 'Personal Projects'
              ? styles.accordion
              : null
          } ${isProjectExpanded ? styles.expanded : null}`}
          key={i}
        >
          <div
            className={styles.companyTitleContainer}
            onClick={
              companyGroup.company === 'Personal Projects'
                ? () => setIsProjectExpanded(!isProjectExpanded)
                : () => null
            }
          >
            <h3 className={styles.companyTitle}>{companyGroup.company}</h3>

            {companyGroup.company === 'Personal Projects' ? (
              <svg
                className={styles.icon}
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M6 9l6 6l6 -6" />
              </svg>
            ) : null}
          </div>

          <div className={styles.carouselContainer}>
            <div className={styles.slider}>
              {companyGroup.projects?.map((project) => (
                <ProjectItem
                  key={project.fields.description}
                  project={project}
                />
              ))}
            </div>
          </div>
        </div>
      ))}
      {modalContent ? (
        <ProjectModal
          project={modalContent}
          setModalContent={setModalContent}
        />
      ) : null}
    </div>
  );
};

export default Projects;
